type ClassLike = {
  parallel: string;
  litera: string;
};

export const getClassKey = (cls: ClassLike) => `${cls.parallel}-${cls.litera}`;
